import Cache from './cache';
//重写toFixed方法采用传统四舍五入
Number.prototype.toFixed = function (n) {
    if (n > 20 || n < 0) {
        throw new RangeError('toFixed() digits argument must be between 0 and 20');
    }
    const number = this;
    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString();
    }
    if (typeof (n) == 'undefined' || n == 0) {
        return (Math.round(number)).toString();
    }
    let result = number.toString();
    const arr = result.split('.');
    // 整数的情况
    if (arr.length < 2) {
        result += '.';
        for (let i = 0; i < n; i += 1) {
            result += '0';
        }
        return result;
    }
    const integer = arr[0];
    const decimal = arr[1];
    if (decimal.length == n) {
        return result;
    }
    if (decimal.length < n) {
        for (let i = 0; i < n - decimal.length; i += 1) {
            result += '0';
        }
        return result;
    }
    result = integer + '.' + decimal.substr(0, n);
    const last = decimal.substr(n, 1);
    // 四舍五入，转换为整数再处理，避免浮点数精度的损失  正数+1 负数-1
    if (parseInt(last, 10) >= 5) {
        const x = Math.pow(10, n);
        result = (Math.round((parseFloat(result) * x)) + (parseFloat(result) > 0 ? 1 : -1)) / x;
        result = result.toFixed(n);
    }
    return result;
};
//工具函数
export default {
    cache:new Cache(),
    setState:function(state,type=1){
        if(!window.KeepAliveNeedClear)window.KeepAliveNeedClear=[];
        let keep=window.KeepAliveNeedClear;
        let key=keep.findIndex((value,index,arr)=>{
            return value.page==state.page;
        });
        if(key>=0)keep.splice(key,1);
        if(type==1)keep.push(state);
    },
    sysClient(){
        // 判断安卓
        function isAndroid() {
            var u = navigator.userAgent;
            if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
                return true;
            }
            return false;
        }
        // 判断设备为 ios
        function isIos() {
            var u = navigator.userAgent;
            if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
                return true;
            }
            return false;
        }
        if(isAndroid())return 'android';
        if(isIos())return 'ios';
        return '';
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
        let ext=dataurl.split(';')[0].split('/')[1];
        let filename=new Date().getTime()+'.'+ext;
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    //将base64转换为Blob
    base64ImageToBlob(base64code){
        let imageType=base64code.split(';')[0].split(':')[1];
        let tmpdata=base64code.split(',')[1];
        var data = window.atob(tmpdata);
        var ia = new Uint8Array(data.length);
        for (var i = 0; i < data.length; i++) {
            ia[i] = data.charCodeAt(i);
        }
        var blob = new Blob([ia], {type: imageType});
        return blob;
    },
    //将base64转换为Blob
    blobToFile(blob,contentType,filename){
        let file = new File([blob], filename, {type: contentType, lastModified: Date.now()});
        return file;
    },
    ENV(){
        if(process.env.NODE_ENV == 'production'){
            if(!window.location.href.includes('-test')){
                return 1;
            }else{
                return 2;
            }
        }else if(process.env.NODE_ENV == 'development'){
            return 3;
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/util.js